<template>
    <div class="homeAboutUs" id="homeAboutUs">
        <p class="aboutUs-title">关于我们</p>
        <div class="aboutUs-detail" v-if="aboutUsData !== null">
        <div class="aboutUs-des">
            <p>{{aboutUsData.des1}}</p>
            <p>{{aboutUsData.des2}}</p>
        </div>
        <video
            class="aboutUs-video"
            :src="`${$baseUrl}${aboutUsData.videoSrc}`"
            controls
        >
        </video>
        </div>
    </div>
</template>

<script>

export default {
    name: 'homeAboutUs',
    components: {
    },
    props: {
        aboutUsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    computed: {

    },
    methods: {
    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  @import '~common/stylus/mixin'

.homeAboutUs
    margin-top 95px
    color $font-black
    z-index 1
    width 100%
    .aboutUs-title
      margin-bottom 35px
      dom_center()
      font-size $font-size-title
    .aboutUs-detail
      dom_center()
      position: absolute;aboutUs
      .aboutUs-des
        position: relative;
        left: 2%;
        width 24%
        height 350px
        dom_center()
        flex-direction column
        background-color $background-white
        padding 38px
        box-shadow $background-shadowBlue 0px 0px 30px 5px
        border-radius 8px
        p:nth-of-type(1)
          font-size 18px
          margin-bottom 5%
        p:nth-of-type(2)
          font-size $font-size-text
          text-align justify
          height 47%
          overflow hidden
          line-height 25px
      .aboutUs-video
        width 37.4%
        height 500px
</style>



// WEBPACK FOOTER //
// src/pages/index/home-aboutUs.vue